<div [class]="contentLoaderClass ? contentLoaderClass : '' + ' loader'">
  <ng-container *ngTemplateOutlet="contentTemplate || defaultContent">
    <!-- Loader Content -->
  </ng-container>
  <ng-template #defaultContent></ng-template>
</div>
